<template>
  <div class="system-parameters">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Lista de parâmetros</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <select
                      v-model="selectedItem"
                      class="form-control"
                      v-on:change="changeComponent()"
                    >
                      <option :value="{}" disabled selected>Selecione um item</option>
                      <option v-for="item in data" :value="item" v-bind:key="item.id">{{item.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 16px">
                <div class="col-12">
                  <component
                    v-bind:is="component_var"
                    @updateContentComponent="updateContent"
                    :data="selectedItem"
                  ></component>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import AuthorLetter from "@/components/system_parameters/AuthorLetter";
import AuthorTag from "@/components/system_parameters/AuthorTag";
import DaysFree from "@/components/system_parameters/DaysFree";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "system-parameters",
  components: {
    AuthorLetter,
    AuthorTag,
    DaysFree
  },
  data() {
    return {
      component_var: "",
      perPage: 100,
      currentPage: 1,
      data: [],
      selectedItem: {},
      items: [
        {
          text: "Parâmetros do sistema",
          active: true
        }
      ]
    };
  },
  mounted() {
    this.providerData();
  },
  methods: {
    changeComponent() {
      this.component_var = this.selectedItem.key;
    },
    providerData() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/system_parameters?${this.urlBuild()}`
        )
        .then(response => {
          this.data = response.data.data;
          this.selectedItem = {};
          this.component_var = "";
          bus.$emit("changeLoading", false);
        });
    },
    urlBuild: function() {
      let url =
        "page[number]=" + this.currentPage + "&page[size]=" + this.perPage;

      return url;
    },
    updateContent: function(val) {
      this.selectedItem.value = val;
    },
    save: function() {
      if (this.selectedItem.value) {
        // bus.$emit("changeLoading", true);
        let promise = axios.put(
          `${process.env.VUE_APP_API_HOST}/api/system_parameters/${this.selectedItem.id}`,
          this.selectedItem
        );

        promise
          .then(response => {
            Swal.fire({
              title: "Item alterado com sucesso",
              icon: "success",
              onClose: () => {
                this.providerData();
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        Swal.fire({
          title: "Atenção",
          text: "Preencha todos os itens",
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>